(() => {
 const root=document.documentElement;
 const category=root.dataset.opCategory||'books';
 const base=root.dataset.opRoot||'/';
 document.body.classList.toggle('op-noir',category==='books');
 document.body.classList.toggle('op-everyday',category!=='books');
 document.querySelector('meta[name="theme-color"]')?.setAttribute('content',category==='books'?'#10090b':'#f7f5ef');
 const home=category==='essentials'?base+'pages/everyday-essentials':base;
 document.querySelectorAll('a[aria-label="Other Pitch home"],a.op4-footer-wordmark,a[data-op-library-home]').forEach(a=>{a.href=home;});
 document.addEventListener('click',event=>{
  const link=event.target.closest('a[href]');if(!link)return;
  let url;try{url=new URL(link.href,location.origin);}catch{return;}
  if(url.origin!==location.origin)return;
  let chosen=null;
  if(url.pathname.includes('/pages/everyday-essentials'))chosen='essentials';
  else if(url.pathname.includes('/collections/other-pitch-books'))chosen='books';
  if(chosen)try{sessionStorage.setItem('op-category',chosen);sessionStorage.setItem('op-genre','all');}catch{}
 });
 const carousel=document.querySelector('[data-op-carousel]');if(!carousel)return;
 const scene=carousel.querySelector('.opp-carousel-scene');
 scene.addEventListener('dragstart',event=>event.preventDefault());
 const slides=Array.from(carousel.querySelectorAll('[data-op-slide]'));
 const dots=Array.from(carousel.querySelectorAll('[data-op-slide-to]'));
 const rotation=carousel.querySelector('[data-op-rotation]');
 const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
 const phone=window.matchMedia('(max-width:799px)');
 let interactionReady=!phone.matches;
 let index=0,timer=null,manualPaused=reduced.matches,pausedUntil=0,keyboardFocus=false,lastInput='pointer',start=null,dragging=false,suppressClick=false,frame=0;
 const interval=4500;
 function hydrateAround(position){
  [-1,0,1].forEach(step=>{
   const slide=slides[(position+step+slides.length)%slides.length];
   const template=slide.querySelector('template[data-op-cover]');
   if(template)template.replaceWith(template.content.cloneNode(true));
  });
 }
 function controls(){
  rotation.setAttribute('aria-pressed',String(manualPaused));
  rotation.setAttribute('aria-label',manualPaused?'Resume automatic book rotation':'Pause automatic book rotation');
  carousel.querySelector('[data-op-rotation-icon]').textContent=manualPaused?'▷':'Ⅱ';
 }
 function render(announce=false){
  const half=Math.floor(slides.length/2);
  slides.forEach((slide,i)=>{
   let offset=(i-index+slides.length)%slides.length;if(offset>half)offset-=slides.length;
   slide.style.setProperty('--slide-offset',offset);slide.style.setProperty('--slide-depth',Math.abs(offset));
   slide.style.setProperty('--slide-turn',(-offset*24)+'deg');slide.style.setProperty('--slide-scale',1-Math.abs(offset)*.06);
   slide.style.zIndex=String(10-Math.abs(offset));slide.dataset.active=String(offset===0);
   slide.setAttribute('aria-hidden',String(offset!==0));slide.tabIndex=offset===0?0:-1;
  });
  dots.forEach((dot,i)=>dot.setAttribute('aria-pressed',String(i===index)));
  carousel.querySelector('[data-op-slide-count]').textContent=String(index+1).padStart(2,'0')+' / '+String(slides.length).padStart(2,'0');
  const active=carousel.querySelector('[data-op-active-book]');active.textContent=slides[index].dataset.title;active.href=slides[index].href;
  if(announce)carousel.querySelector('[data-op-carousel-status]').textContent=slides[index].dataset.title+', book '+(index+1)+' of '+slides.length;
 }
 function schedule(){
  clearTimeout(timer);timer=null;controls();
  if(!interactionReady||manualPaused||keyboardFocus||dragging||document.hidden)return;
  const remaining=pausedUntil-Date.now();
  timer=setTimeout(()=>{if(Date.now()<pausedUntil){schedule();return;}index=(index+1)%slides.length;hydrateAround(index);render();schedule();},remaining>0?remaining:interval);
 }
 function select(i){interactionReady=true;index=(i+slides.length)%slides.length;hydrateAround(index);pausedUntil=Date.now()+interval;render(true);schedule();}
 carousel.querySelector('[data-op-next]').addEventListener('click',()=>select(index+1));
 carousel.querySelector('[data-op-previous]').addEventListener('click',()=>select(index-1));
 dots.forEach((dot,i)=>dot.addEventListener('click',()=>select(i)));
 rotation.addEventListener('click',()=>{interactionReady=true;manualPaused=!manualPaused;pausedUntil=0;if(!manualPaused)keyboardFocus=false;schedule();});
 function beginMobileRotation(){if(interactionReady)return;interactionReady=true;hydrateAround(index);pausedUntil=Date.now()+interval;schedule();}
 document.addEventListener('pointerdown',beginMobileRotation,{once:true,passive:true});
 document.addEventListener('keydown',beginMobileRotation,{once:true});
 window.addEventListener('scroll',beginMobileRotation,{once:true,passive:true});
 document.addEventListener('keydown',event=>{if(event.key==='Tab')lastInput='keyboard';});
 document.addEventListener('pointerdown',()=>{lastInput='pointer';if(keyboardFocus){keyboardFocus=false;schedule();}},{capture:true});
 carousel.addEventListener('focusin',()=>{if(lastInput==='keyboard'){keyboardFocus=true;schedule();}});
 carousel.addEventListener('focusout',()=>{queueMicrotask(()=>{if(!carousel.contains(document.activeElement)){keyboardFocus=false;schedule();}});});
 carousel.addEventListener('keydown',event=>{if(event.key==='ArrowRight'){event.preventDefault();select(index+1);}else if(event.key==='ArrowLeft'){event.preventDefault();select(index-1);}});
 function resetTilt(){scene.style.setProperty('--cursor-x','0deg');scene.style.setProperty('--cursor-y','0deg');}
 scene.addEventListener('pointerdown',event=>{if(event.button!==0)return;start={x:event.clientX,y:event.clientY,id:event.pointerId};pausedUntil=Date.now()+interval;});
 scene.addEventListener('pointermove',event=>{
  const dx=start?event.clientX-start.x:0,dy=start?event.clientY-start.y:0;
  if(start&&!dragging&&Math.abs(dx)>9&&Math.abs(dx)>Math.abs(dy)*1.2){dragging=true;scene.setPointerCapture(event.pointerId);carousel.dataset.dragging='true';schedule();}
  if(dragging){if(event.cancelable)event.preventDefault();scene.style.setProperty('--drag-offset',Math.max(-120,Math.min(120,dx))+'px');}
  if(event.pointerType==='mouse'&&!reduced.matches&&!frame){
   const rect=scene.getBoundingClientRect(),x=(event.clientX-rect.left)/rect.width-.5,y=(event.clientY-rect.top)/rect.height-.5;
   frame=requestAnimationFrame(()=>{scene.style.setProperty('--cursor-x',Math.max(-7,Math.min(7,x*12))+'deg');scene.style.setProperty('--cursor-y',Math.max(-4,Math.min(4,-y*7))+'deg');frame=0;});
  }
 });
 function finish(event){
  if(!start)return;
  const dx=event.clientX-start.x,wasDragging=dragging;
  start=null;dragging=false;carousel.dataset.dragging='false';scene.style.setProperty('--drag-offset','0px');
  if(scene.hasPointerCapture(event.pointerId))scene.releasePointerCapture(event.pointerId);
  if(wasDragging){suppressClick=true;setTimeout(()=>{suppressClick=false;},350);if(event.type!=='pointercancel'&&Math.abs(dx)>35)select(index+(dx<0?1:-1));}
  pausedUntil=Date.now()+interval;schedule();
 }
 scene.addEventListener('pointerup',finish);scene.addEventListener('pointercancel',finish);
 scene.addEventListener('pointerleave',()=>{if(!dragging)resetTilt();});
 carousel.addEventListener('click',event=>{if(suppressClick){event.preventDefault();event.stopPropagation();}},{capture:true});
 slides.forEach((slide,i)=>slide.addEventListener('click',event=>{if(!suppressClick&&i!==index){event.preventDefault();select(i);}}));
 window.addEventListener('blur',()=>{start=null;dragging=false;carousel.dataset.dragging='false';scene.style.setProperty('--drag-offset','0px');resetTilt();schedule();});
 document.addEventListener('visibilitychange',schedule);
 reduced.addEventListener('change',()=>{if(reduced.matches){manualPaused=true;resetTilt();}schedule();});
 render();
 carousel.dataset.opReady='true';
 function warmNearby(){
  if('requestIdleCallback' in window)requestIdleCallback(()=>hydrateAround(index),{timeout:1600});
  else setTimeout(()=>hydrateAround(index),500);
  schedule();
 }
 if(document.readyState==='complete')warmNearby();else window.addEventListener('load',warmNearby,{once:true});
})();
